module.exports = __webpack_public_path__ + "static/media/iStock-478272220.00beadaa.jpg";